// DeltaSuite — internal staff identity.
// Aligned to the DeltaSuite Brand & Build Standard:
// IBM Plex Sans/Mono, master amber accent, engineered (4px radius, hairline borders).
// Module-specific accents live in the style guide; DeltaDial currently uses the
// master amber until it claims its own module hue.

export const colors = {
  // Surface — cool off-white per the style guide (#F7F8FA). Two steps so a
  // recessed panel can sit under the primary surface without needing a border.
  surface: '#f7f8fa',
  'surface-sunk': '#eef0f4',

  // Graphite — primary ink and lighter steps for secondary / tertiary text and
  // hairline borders. Mapped to the style guide's text/text-mid/text-dim plus
  // border/border-strong ramp.
  'graphite-900': '#1c1f26',
  'graphite-700': '#4a5160',
  'graphite-500': '#6b7280',
  'graphite-300': '#c5cad4',
  'graphite-100': '#dee2e8',

  // Signal amber — DeltaSuite master accent (#F5A524) and hover (#C77F0E).
  // Reserved for active state / "you're on" / primary CTAs. Single accent —
  // the guide is explicit that we don't mix module hues into another surface.
  'signal-amber': '#f5a524',
  'signal-amber-hover': '#c77f0e',

  // Accent progress — slate-blue for progress fills, points-target ring,
  // counters, "delta from target" affordances. Cool counterpoint to amber
  // so a panel showing both reads as "active state + progress" rather than
  // double-warm. Picked from a 3-way colour exploration round; see R6 PR
  // for the side-by-side reasoning.
  'accent-progress': '#3e5a78',
  'accent-progress-hover': '#2e455d',
} as const;

export const fonts = {
  // IBM Plex Sans for body and headings (heavier weights). No serif.
  // IBM Plex Mono for numerics, codes, IDs, eyebrow labels.
  sans: '"IBM Plex Sans", system-ui, -apple-system, sans-serif',
  mono: '"IBM Plex Mono", ui-monospace, SFMono-Regular, monospace',
} as const;

// Δ — uppercase Greek delta, the DeltaSuite master mark.
// Used as a small monoline glyph, not big and decorative.
export const masterMark = 'Δ' as const;

export type ColorToken = keyof typeof colors;
export type FontToken = keyof typeof fonts;
